export const SITE_ID_PHARMA = '1'
export const SITE_ID_HEALTHTECH = '2'

export default {
  SITE_ID_PHARMA,
  SITE_ID_HEALTHTECH
}
